const styles = theme => ({
  cardHeader: {
    backgroundColor: theme.palette.background.default
  },
  cardTitle: {
    fontSize: '1em'
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/layouts/components/notification-sidenav/today-tab.style.js